/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import Footer from '../components/Footer';
import IntroduceTopMenu from '../components/IntroduceTopMenu';
import Slider from 'react-slick';
import * as Consts from '../components/Consts';

import creative_01 from '../images/Content/creative_01.jpg';
import creative_02 from '../images/Content/creative_02.jpg';
import creative_03 from '../images/Content/creative_03.jpg';
import openstudy_01 from '../images/Content/openstudy_01.jpg';
import openstudy_02 from '../images/Content/openstudy_02.jpg';
import openstudy_03 from '../images/Content/openstudy_03.jpg';
import solitary_01 from '../images/Content/solitary_01.jpg';
import solitary_02 from '../images/Content/solitary_02.jpg';
import solitary_03 from '../images/Content/solitary_03.jpg';
import individual_01 from '../images/Content/individual_01.jpg';
import individual_02 from '../images/Content/individual_02.jpg';
import individual_03 from '../images/Content/individual_03.jpg';
import social_01 from '../images/Content/social_01.jpg';
import social_02 from '../images/Content/social_02.jpg';
import social_03 from '../images/Content/social_03.jpg';

var _typeDescMap = {
  'creative': '시각적인 환경에 민감한 학습자들에게 다락방과 같은 색감과 분위기로 시각적인 안정감을 주어 학습력을 증진시켜줍니다.',
  'open_study': '혼자 있는 공간에서는 잠이 오고 오히려 집중이 되지 않는 경우가 있습니다. 다른 사람들의 공부하는 모습을 보며 자극을 받고 동질감을 느낌으로써 학습효율을 높일 수 있는 공간입니다.',
  'solitary': '적당한 독립을 원하는 학습자에게 안정감을 주는 공간입니다. 자체 개발한 가구로 밝은 분위기와 편리성을 높였습니다.',
  'individual': '혼자 계획하고 스스로 깊이 생각하기를 좋아하는 학습자에게 효과적인 공간입니다.',
  'social_space': '음악이 조용히 나오고 노트북 사용, 간단한 다과, 조용한 대화가 허용되는 공간입니다. 장소의 전환을 통해 집중력을 새롭게 충전할 수 있고 학습시간을 늘릴 수 있습니다.'
}

var _typeImgMap = {
  'creative': [{img: creative_01}, {img: creative_02}, {img: creative_03}],
  'open_study': [{img: openstudy_01}, {img: openstudy_02}, {img: openstudy_03}],
  'solitary':  [{img: solitary_01}, {img: solitary_02}, {img: solitary_03}],
  'individual':  [{img: individual_01}, {img: individual_02}, {img: individual_03}],
  'social_space':  [{img: social_01}, {img: social_02}, {img: social_03}]
}

class Introduce01 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: 'creative',
      typeImg: _typeImgMap['creative'],
      isTopMenu: false
    };
  }

  componentDidMount() {
  }

  /**
   * 탭 변경 event
   */
  _doChangeType = (type, e) => {
    // 이미지 슬라이드가 다른 페이지면 맨 앞으로 이동
    this.slider.slickGoTo(0);

    this.setState({
      type: type,
      typeImg: _typeImgMap[type]
    });
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/introduce" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">

                  <IntroduceTopMenu link={this.props.location.pathname} />

                  <div className="info-vis img01">
                    <p className="stxt">7가지 학습유형에 따른</p>
                    <p className="btxt"><strong>토즈 스터디센터</strong>만의<br/>5가지 공간을 설계하다.</p>
                    <p className="ctxt">Since 2010</p>
                  </div>
                  
                  <div className="info-tbox">
                    <ul className="btxt">
                      <li>개개인의 발달된 지능에 따라</li>
                      <li>효율이 극대화 되는</li>
                      <li><strong>학습공간이 모두 다르다.</strong></li>
                    </ul>
                    <p className="name">
                      <span className="img"><span className="blind">하워드 가드너</span></span>
                      <span className="stxt">하워드 가드너</span>
                    </p>
                  </div>

                  <div className="info-slide-cont">
                    <p className="tit"><strong>최적의 학습환경</strong>을 위한 5가지 공간</p>
                    <Slider {...Consts.SLIDE_INTRODUCE_SETTINGS} className="info-slide-tap">
                      <div className={this.state.type === 'creative' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'creative')}>CREATIVE</a></div>
                      <div className={this.state.type === 'open_study' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'open_study')}>OPEN STUDY</a></div>
                      <div className={this.state.type === 'solitary' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'solitary')}>SOLITARY</a></div>
                      <div className={this.state.type === 'individual' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'individual')}>INDIVIDUAL</a></div>
                      <div className={this.state.type === 'social_space' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'social_space')}>SOCIAL SPACE</a></div>
                    </Slider>
                    
                    <p className="stxt">{_typeDescMap[this.state.type]}</p>
                    <Slider ref={ref => (this.slider = ref)} dots={true} {...Consts.SLIDE_INTRODUCE_SETTINGS} className="info-slide">
                      {this.state.type ? this.state.typeImg.map((entity, index) => <div key={index}><img src={entity.img} alt={this.state.type + index} /></div>) : ''}
                    </Slider>

                  </div>

                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Introduce01;